import { BrowserRouter, Route, Switch } from "react-router-dom";
import LogsTable from "./LogsTable";
import Newkeys from "./Newkeys";

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path="/logs/:secret">
            <LogsTable />
          </Route>
          <Route path="/newkeys">
            <Newkeys />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default App;
